<template>
<div class="chapter">
<div class="inner_page">
<p class="block_" id="id_Toc445470978">La Terre Vorace</p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_2">Livre Élémentaire II</p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_3">Rain Oxford</p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_4">Traduit par Camille Fankhauser</p>
<p class="block_5"><span class="text_" lang="en"><br class="calibre1" id="calibre_pb_0"/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?3c33ff9a